/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ProjectOptionInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectOptionsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectOptions
   * @summary Вернёт список всех ключей сохранённых настроек проекта.
   * @request GET:/project/{projectId}/ProjectOptions/all-keys
   * @secure
   */
  projectOptionsGetAllKeys = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/project/${projectId}/ProjectOptions/all-keys`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectOptions
   * @summary Сохранит в БД значение проектной настройки.
   * @request POST:/project/{projectId}/ProjectOptions
   * @secure
   */
  projectOptionsSetOption = (
    projectId: string,
    data: ProjectOptionInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/project/${projectId}/ProjectOptions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectOptions
   * @summary Вернёт значение проектной настройки, если она есть в БД.
   * @request GET:/project/{projectId}/ProjectOptions/GetOption/{key}
   * @secure
   */
  projectOptionsGetOption = (projectId: string, key: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/${projectId}/ProjectOptions/GetOption/${key}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectOptions
   * @summary Удалит проектную настройку.
   * @request DELETE:/project/{projectId}/ProjectOptions/DeleteOption
   * @secure
   */
  projectOptionsRemoveOption = (
    projectId: string,
    query: {
      /** ключ проектной настройки. */
      key: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/project/${projectId}/ProjectOptions/DeleteOption`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectOptions
   * @summary Вернёт значений проектной настройки, если она есть в БД.
   * @request GET:/project/{projectId}/ProjectOptions/{key}
   * @deprecated
   * @secure
   */
  projectOptionsGetWellIds = (projectId: string, key: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/${projectId}/ProjectOptions/${key}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
